import React, { useRef } from "react";
import cx from "classnames";
import styles from "./DkStatisticEn.module.css";

import { useState } from "react";
import { useEffect } from "react";
import Image from "next/image";

import { motion } from "framer-motion";
import uuid from "react-uuid";
import { statisticTitleEn } from "../../Data/dkStatisticData";
import { statisticData } from "../../Data/dkStatisticData";
import Link from "next/link";

const DkStatisticEn = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [logoList, setLogoList] = useState([]);

  const scrollingTab = useRef();

  const activeTabHandler = (id) => {
    try {
      if (id > 0 && id < 7) {
        setActiveTab(id);
        let parentPos = scrollingTab.current.getBoundingClientRect();
        let childPos = document
          .getElementById(`tabHeader_${id}`)
          .getBoundingClientRect();
        scrollingTab.current.scrollBy({
          top: 0,
          left: childPos.left - parentPos.left,
          behavior: "smooth",
        });
      } else {
        return;
      }
    } catch (error) {}
  };

  useEffect(() => {
    setLogoList(statisticData.filter((i) => i.id === activeTab)[0].logosList);
  }, [activeTab]);

  return (
    <div
      lang="en"
      className={cx(
        styles.container,
        "w-100",
        "d-flex",
        "flex-column",
        "align-items-center",
        "justify-content-center",
        "enFontFamily"
      )}
    >
      <div
        className={cx(
          styles.topContent,
          "d-flex",
          "align-items-center",
          "justify-content-center",
          "flex-column"
        )}
      >
        <h1 className={cx(styles.topContentH1)}>Digikala E-Commerce Group</h1>
        <p className={cx(styles.topContentP)}>
          {
            "Digikala E-commerce group has become a complete ecosystem of online businesses. Digikala Group's approach has been to complete the value creation chain for Iran's digital economy. In this way, it has provided the necessary infrastructures to meet the needs of different business types."
          }
        </p>
      </div>
      <div
        className={cx(
          styles.statisticContainer,
          "d-flex",
          "flex-column",
          "align-items-center",
          "justify-content-start",
          "w-100"
        )}
      >
        <div
          className={cx(
            styles.statisticHeaderMenu,
            "d-flex",
            "align-items-center",
            "justify-content-center",
            "w-100"
          )}
        >
          <div>
            <button
              onClick={() => {
                activeTabHandler(activeTab - 1);
              }}
              className={cx(
                styles.prevBtn,
                styles.statisticHeaderMenuSrollControl,
                activeTab === 1 &&
                  styles.statisticHeaderMenuSrollControlDiactive,
                "d-flex",
                "d-lg-none",
                "align-items-center",
                "justify-content-center",
                "d-lg-none",
                "p-0",
                "m-0",
                "enFontFamily"
              )}
              id="dkStatisticPrevStatistic"
              aria-label="prevous statisticr"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.41417 12L11.9957 6.5368L7.41406 1"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6.53516L1 6.53516"
                  stroke="white"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
          <div
            ref={scrollingTab}
            className={cx(
              styles.headerTabMenuWrapper,
              "d-flex",
              "flex-fill",
              "align-items-center",
              "justify-content-start"
            )}
          >
            {statisticTitleEn.map((itemTitle, key) => (
              <div
                id={`tabHeader_${itemTitle.id}`}
                aria-label={`number ${itemTitle.id} statistic`}
                key={uuid()}
              >
                <button
                  onClick={() => activeTabHandler(itemTitle.id)}
                  className={cx(
                    styles.headerMenuButton,
                    activeTab === itemTitle.id && styles.headerMenuButtonActive,
                    "d-flex",
                    "align-items-center",
                    "justify-content-center",
                    "p-0",
                    "m-0",
                    "enFontFamily"
                  )}
                >
                  {itemTitle.title}
                </button>
              </div>
            ))}
          </div>
          <div>
            <button
              onClick={() => {
                activeTabHandler(activeTab + 1);
              }}
              className={cx(
                styles.nextBtn,
                styles.statisticHeaderMenuSrollControl,
                activeTab === 6 &&
                  styles.statisticHeaderMenuSrollControlDiactive,
                "d-flex",
                "d-lg-none",
                "align-items-center",
                "justify-content-center",
                "d-lg-none",
                "p-0",
                "m-0"
              )}
              id="dkStatisticNextStatistic"
              aria-label="next statisticr"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.58583 1L1.00429 6.4632L5.58594 12"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 6.46484L12 6.46484"
                  stroke="white"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
        </div>
        <div
          className={cx(
            styles.statisticNumberContainer,
            "d-flex",
            "flex-column",
            "flex-lg-row",
            "align-items-lg-start",
            "align-items-center",
            "justify-content-lg-start",
            "justify-content-center",
            "w-100",
            "flex-lg-wrap",
            "enFontFamily"
          )}
        >
          {statisticData
            .filter((i) => i.id === activeTab)[0]
            .statisticList.map((item, key) => (
              <motion.div
                initial={{ x: "50%", opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 0.1 * key, stiffness: 90 }}
                key={uuid()}
                className={cx(
                  styles.statisticItemWrapper,
                  "d-flex",
                  "flex-column",
                  "align-items-lg-start",
                  "align-items-center",
                  "justify-content-start"
                  //   "w-100"
                )}
              >
                <h2
                  className={cx(
                    styles.statisticNumber,
                    "p-0",
                    "m-0",
                    "enFontFamily"
                  )}
                >
                  {item.number.replace("/", ".")}
                </h2>
                <span
                  className={cx(
                    styles.unitStatistic,
                    "p-0",
                    "m-0",
                    "enFontFamily"
                  )}
                >
                  {item.unitEn}
                </span>
                <span
                  className={cx(
                    styles.statisticDescribe,
                    "p-0",
                    "m-0",
                    "enFontFamily"
                  )}
                >
                  {item.describeEn}
                </span>
              </motion.div>
            ))}
        </div>
        <div
          className={cx(
            styles.statisticLogoContainer,
            "d-flex",
            "align-items-center",
            "justify-content-center",
            "flex-wrap",
            "w-100"
          )}
        >
          {statisticData
            .filter((i) => i.id === activeTab)[0]
            .logosList.map((item, key) => (
              <motion.div
                initial={{ y: "50%", opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.1 * key, stiffness: 90 }}
                key={uuid()}
                className={cx(
                  styles.statisticLogoWrapper,
                  "d-flex",
                  "align-items-center",
                  "justify-content-center",
                  logoList.length === 1 && styles.span2Cell
                )}
              >
                <motion.div
                  whileHover={{
                    y: -5,
                    transition: {
                      duration: 0.3,
                      stiffness: 70,
                    },
                  }}
                  className={cx(
                    styles.eachLogoStyles,
                    "d-flex",
                    "align-items-center",
                    "justify-content-center",
                    (key === logoList.length - 1 ||
                      key === logoList.length - 2) &&
                      styles.eachLogoStylesNoBorderBottom
                  )}
                >
                  {item.isActive ? (
                    <Link target="_blank" href={item.linkEn}>
                      <Image
                        width="100%"
                        height="100%"
                        src={item.logo}
                        alt="digikala"
                      />
                    </Link>
                  ) : (
                    <Image
                      width="100%"
                      height="100%"
                      src={item.logo}
                      alt="digikala"
                    />
                  )}
                </motion.div>
              </motion.div>
            ))}
        </div>
        <h6 className="mt-2 enFontFamily">
          Data Source : Digikala Annual Report 2023-24
        </h6>
      </div>
    </div>
  );
};

export default DkStatisticEn;
